import register from "preact-custom-element";

import MiniCart from "./components/MiniCart";

register(MiniCart, "uwp-minicart");
